module.exports = __webpack_public_path__ + "img/1537829692.20b32166.jpg";